import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, GFunc, GState, LogicX, NavX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { VStack } from "IZOX/_X";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Denied } from "IZOX/ARCS/Default";

/**
 * @augments {Component<Props, State>}
 */
class PRedirect extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates(() => {
      setTimeout(() => {
        this.Redirect();
      }, 500);
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PRedirect.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toPage = (page) => {
    let {history} = this.props;
    NavX.Goto(history, page);
  }

  Redirect (){
    if(!GState.loggedIn) return;

    let roles = GFunc.GetUserRoles();
    let status = GFunc.GetUserStatus();

    console.log(status);

    switch(status){
      case "Locked": this._toPage("/User/Locked"); return;
      default: 
      case "Deleted": 
      case "Inactive": this._toPage("/User/Denied"); return;
      case "Applying": this._toPage("/User/Applying"); return;
      case "Verifying": this._toPage("/User/Verifying"); return;
      case "PendingToApprove": this._toPage("/User/PendingToApprove"); return;
      case "Rejected": this._toPage("/User/Rejected"); return;
      case "Active":
      case "Profiling": break;
    }
    
    if(LogicX.includesOneOf(roles, ["Agent"])){
      if(status === "Profiling"){
        GState.UPDATE("profileStep", 0);
        GState.UPDATE("profileFormData", {});
        this._toPage("/Agent/Profile"); return;
      }else if(status === "Active"){
        this._toPage("/Agent/Dashboard"); return;
      }
    }

    if(LogicX.includesOneOf(roles, ["DCustomer", "Client"])){
      if(status === "Profiling"){
        GState.UPDATE("profileStep", 0);
        GState.UPDATE("profileFormData", {});
        this._toPage("/DCustomer/Profile"); return;
      }else if(status === "Active"){
        this._toPage("/DCustomer/Dashboard"); return;
      }
    }

    if(LogicX.includesOneOf(roles, ["Insurer"])){
      if(status === "Active"){
        this._toPage("/Insurer/AllPolicies"); return;
      }
    }

    this._toPage("/Home");

  }

  render(){
    if(!GState.loggedIn) return <Denied/>;
    return (
      <VStack>

      </VStack>
    );
  }

}

export default withRouter(observer(PRedirect));
